import { render, staticRenderFns } from "./DetailType8.vue?vue&type=template&id=301c56b7&"
import script from "./DetailType8.vue?vue&type=script&lang=js&"
export * from "./DetailType8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports